function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function formatMoneyFromCents(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol'
    }).format(cents / 100);
  } catch (error) {
    return `$${(cents / 100).toFixed(2)}`;
  }
}

function updateCompleteSetAddToCartPrice(section = document) {
  const priceElement = section.querySelector('.sa-add-to-cart-price');
  if (!priceElement) return;

  const basePrice = Number(priceElement.dataset.basePrice || 0);
  const bundle = section.querySelector('.sa-bundle');

  if (bundle) {
    const discount = Number(bundle.dataset.bundleDiscount || 0);
    const discountAmount = Math.floor(basePrice * Math.max(0, discount) / 100);
    const discountedBasePrice = Math.max(0, basePrice - discountAmount);
    const selectedBundleItems = Array.from(section.querySelectorAll('.sa-bundle__checkbox:checked:not(:disabled)'));
    const selectedBundlePrice = selectedBundleItems.reduce((total, checkbox) => {
      return total + Number(checkbox.dataset.price || 0);
    }, 0);
    const bundleTotal = selectedBundleItems.length ? discountedBasePrice + selectedBundlePrice : basePrice;
    const totalElement = bundle.querySelector('[data-bundle-total]');
    const savingsTextElement = bundle.querySelector('.sa-bundle__save-text');
    const mainComparePrice = bundle.querySelector('.sa-bundle__item--main .sa-complete-set__compare-price');
    const mainDiscountedPrice = bundle.querySelector('.sa-bundle__item--main .sa-complete-set__price');

    bundle.dataset.bundleBasePrice = String(basePrice);
    bundle.dataset.bundleBaseDiscountedPrice = String(discountedBasePrice);
    if (totalElement) totalElement.textContent = formatMoneyFromCents(bundleTotal);
    if (savingsTextElement) savingsTextElement.hidden = selectedBundleItems.length === 0;
    if (mainComparePrice) mainComparePrice.textContent = formatMoneyFromCents(basePrice);
    if (mainDiscountedPrice) mainDiscountedPrice.textContent = formatMoneyFromCents(discountedBasePrice);
    if (selectedBundleItems.length) {
      priceElement.textContent = formatMoneyFromCents(bundleTotal);
      return;
    }
  }

  const addOnPrice = Array.from(section.querySelectorAll('.sa-complete-set__checkbox:checked')).reduce((total, checkbox) => {
    return total + Number(checkbox.dataset.price || 0);
  }, 0);

  priceElement.textContent = formatMoneyFromCents(basePrice + addOnPrice);
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('.sa-complete-set__checkbox, .sa-bundle__checkbox')) return;
  const section = event.target.closest('section') || document;
  updateCompleteSetAddToCartPrice(section);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('section').forEach((section) => updateCompleteSetAddToCartPrice(section));
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function isSeriousAboutJudgeMeMobile() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function syncSeriousAboutJudgeMeState() {
  if (!isSeriousAboutJudgeMeMobile()) return;

  document.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
    const setImportant = (element, property, value) => {
      if (element && element.style.getPropertyValue(property) !== value) {
        element.style.setProperty(property, value, 'important');
      }
    };

    const reviews = widget.querySelectorAll('.jdgm-rev');
    const summaryText = widget.querySelector('.jdgm-rev-widg__summary-text');
    const reviewCountText = [
      widget.getAttribute('data-number-of-reviews'),
      summaryText?.textContent
    ].filter(Boolean).join(' ');

    const hasNoReviewMessage = /be\s+the\s+first\s+to\s+write\s+a\s+review/i.test(summaryText?.textContent || '');
    const hasReviews = reviews.length > 0 && !hasNoReviewMessage && !/\b0\s+reviews?\b/i.test(reviewCountText);
    const hasMedia = Boolean(
      widget.querySelector(
        '.jdgm-gallery__thumbnail img, .jdgm-gallery__thumbnail-wrapper img, .jdgm-rev__pic-img, .jdgm-rev__pics img, .jdgm-pic, .jdgm-picture'
      )
    );

    widget.querySelectorAll('.jdgm-write-rev-link').forEach((button) => {
      button.textContent = 'WRITE A REVIEW';
      button.closest('.jdgm-widget-actions-wrapper')?.classList.add('sa-jdgm-actions');
    });

    widget.querySelectorAll('.jdgm-rev-widg__summary').forEach((summary) => {
      const rating = summary.querySelector('.jdgm-rev-widg__summary-average');
      if (rating && summary.firstElementChild !== rating) {
        summary.prepend(rating);
      }
    });

    widget.querySelectorAll('.jdgm-rev-widg__summary-average').forEach((rating) => {
      const match = rating.textContent.match(/\d+(?:[.,]\d+)?/);
      if (!match) return;

      const value = Number(match[0].replace(',', '.'));
      if (Number.isNaN(value)) return;

      rating.textContent = value.toFixed(1);

      const summary = rating.closest('.jdgm-rev-widg__summary');
      const stars = summary?.querySelector('.jdgm-rev-widg__summary-stars');
      if (stars) {
        const visualValue = value >= 5 ? 5 : Math.floor(value * 2) / 2;
        stars.classList.add('sa-rating-stars');
        stars.setAttribute('aria-label', `${value.toFixed(1)} out of 5 stars`);
        stars.innerHTML = Array.from({ length: 5 }, (_, index) => {
          const fill = Math.max(0, Math.min(100, (visualValue - index) * 100));
          return `<span class="sa-star" style="--sa-star-fill: ${fill}%"><span class="sa-star-empty">☆</span><span class="sa-star-fill">★</span></span>`;
        }).join('');
      }
    });

    if (summaryText && hasReviews) {
      const countMatch = reviewCountText.match(/(\d+)\s+reviews?/i);
      if (countMatch) {
        summaryText.textContent = `based on ${countMatch[1]} reviews`;
      }
    }

    widget.querySelectorAll('.jdgm-gallery-title, .jdgm-medals__title, .jdgm-rev-widg__medals-title').forEach((title) => {
      title.textContent = 'CUSTOMER PHOTOS & VIDEOS';
      title.classList.add('sa-jdgm-gallery-title');
      title.closest('.jdgm-gallery, .jdgm-medals, .jdgm-rev-widg__medals')?.classList.add('sa-jdgm-gallery');
    });

    widget.querySelectorAll('.jdgm-gallery__wrapper, .jdgm-gallery__container, .jdgm-gallery__list, .jdgm-gallery__content').forEach((galleryContent) => {
      galleryContent.classList.add('sa-jdgm-gallery-content');
    });

    widget.querySelectorAll('.jdgm-rev-widg__header img, .sa-jdgm-gallery img').forEach((image) => {
      const squareWrapper = image.closest(
        'a, button, picture, .jdgm-gallery__thumbnail-wrapper, [class*="thumbnail" i], [class*="photo" i], [class*="picture" i], [class*="pic" i], [class*="image" i], [class*="media" i]'
      ) || image.parentElement;

      if (squareWrapper === image) {
        image.classList.remove('sa-jdgm-media-square', 'sa-jdgm-media-square-img');
        image.classList.add('sa-jdgm-direct-square-img');
        return;
      }

      squareWrapper?.classList.add('sa-jdgm-media-square');
      image.classList.remove('sa-jdgm-direct-square-img');
      image.classList.add('sa-jdgm-media-square-img');
    });

    widget.querySelectorAll('.jdgm-rev-widg__header [style*="background-image"], .sa-jdgm-gallery [style*="background-image"]').forEach((mediaItem) => {
      mediaItem.classList.add('sa-jdgm-media-square');
    });

    const header = widget.querySelector('.jdgm-rev-widg__header');
    const actions = widget.querySelector('.sa-jdgm-actions, .jdgm-widget-actions-wrapper');
    const rowActions = widget.querySelector('.jdgm-row-actions');
    const gallery = widget.querySelector('.sa-jdgm-gallery, .jdgm-gallery, .jdgm-medals, .jdgm-rev-widg__medals');
    const galleryTitle = widget.querySelector('.sa-jdgm-gallery-title, .jdgm-gallery-title, .jdgm-medals__title, .jdgm-rev-widg__medals-title');
    const galleryContents = widget.querySelectorAll('.sa-jdgm-gallery-content, .jdgm-gallery__wrapper, .jdgm-gallery__container, .jdgm-gallery__list, .jdgm-gallery__content');
    const thumbnails = widget.querySelectorAll('.jdgm-gallery__thumbnail, .jdgm-gallery__thumbnail-wrapper');

    if (rowActions && !rowActions.querySelector('.jdgm-rev-widg__filter, .jdgm-filter-trigger, .sa-jdgm-filter-fallback')) {
      const fallbackFilter = document.createElement('button');
      fallbackFilter.type = 'button';
      fallbackFilter.className = 'sa-jdgm-filter-fallback';
      fallbackFilter.innerHTML = '<span class="sa-jdgm-filter-icon" aria-hidden="true"></span><span>Filters</span>';
      rowActions.appendChild(fallbackFilter);
    }

    if (rowActions && !rowActions.querySelector('.sa-jdgm-actions-visual')) {
      const visualActions = document.createElement('div');
      visualActions.className = 'sa-jdgm-actions-visual';
      visualActions.innerHTML = '<button class="sa-jdgm-sort-visual" type="button"><span>Most Recent</span><span class="sa-jdgm-chevron" aria-hidden="true"></span></button>';
      rowActions.prepend(visualActions);
    }

    const visualSort = rowActions?.querySelector('.sa-jdgm-sort-visual');
    const activateControl = (control) => {
      const target = control?.matches('button, a, select, summary, [role="button"]')
        ? control
        : control?.querySelector('button, a, select, summary, [role="button"]');

      if (!target) return;

      target.focus?.();

      if (target.tagName === 'SELECT' && typeof target.showPicker === 'function') {
        target.showPicker();
        return;
      }

      ['mousedown', 'mouseup', 'click'].forEach((eventName) => {
        target.dispatchEvent(new MouseEvent(eventName, {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      });
    };

    if (visualSort && !visualSort.dataset.saBound) {
      visualSort.dataset.saBound = 'true';
      visualSort.addEventListener('click', (event) => {
        event.preventDefault();
        const currentSort = rowActions?.querySelector('.jdgm-rev-widg__sort-wrapper, .jdgm-sort-dropdown-wrapper, .jdgm-sort-dropdown');
        activateControl(currentSort);
      });
    }

    setImportant(header, 'margin-bottom', '14px');
    setImportant(rowActions, 'width', '100%');
    setImportant(rowActions, 'max-width', '100%');
    setImportant(rowActions, 'box-sizing', 'border-box');
    setImportant(rowActions, 'display', 'block');
    setImportant(rowActions, 'align-items', 'center');
    setImportant(rowActions, 'margin', '0 auto 14px');
    setImportant(rowActions, 'padding', '16px 28px');
    setImportant(rowActions, 'min-height', '62px');

    const sortControl = rowActions?.querySelector('.jdgm-rev-widg__sort-wrapper, .jdgm-sort-dropdown-wrapper, .jdgm-sort-dropdown');
    const filterControl = rowActions?.querySelector('.jdgm-rev-widg__filter, .jdgm-rev-widg__filter-link, .jdgm-filter-trigger, .sa-jdgm-filter-fallback');
    setImportant(sortControl, 'grid-column', '1');
    setImportant(sortControl, 'justify-self', 'start');
    setImportant(sortControl, 'text-align', 'left');
    setImportant(sortControl, 'font-size', '15px');
    setImportant(filterControl, 'grid-column', '2');
    setImportant(filterControl, 'justify-self', 'end');
    setImportant(filterControl, 'text-align', 'right');
    setImportant(filterControl, 'font-size', '15px');

    widget.querySelectorAll('.jdgm-rev').forEach((review) => {
      setImportant(review, 'width', '100%');
      setImportant(review, 'max-width', '100%');
      setImportant(review, 'box-sizing', 'border-box');
      setImportant(review, 'margin-left', 'auto');
      setImportant(review, 'margin-right', 'auto');
    });

    if (hasReviews) {
      setImportant(header, 'padding-bottom', '0');
      setImportant(actions, 'padding-bottom', '30px');
      setImportant(gallery, 'margin-top', '18px');
      setImportant(gallery, 'margin-bottom', '0');
      setImportant(gallery, 'padding-top', '0');
      setImportant(gallery, 'padding-bottom', '0');
      setImportant(galleryTitle, 'margin-bottom', '6px');
    } else {
      setImportant(header, 'width', '100%');
      setImportant(header, 'max-width', '100%');
      setImportant(header, 'box-sizing', 'border-box');
      setImportant(header, 'padding', '48px 30px 46px');
      setImportant(actions, 'margin-top', '24px');
      setImportant(actions, 'padding-bottom', '0');
      widget.querySelectorAll('.jdgm-write-rev-link').forEach((button) => {
        setImportant(button, 'width', '236px');
        setImportant(button, 'min-width', '236px');
        setImportant(button, 'max-width', '236px');
        setImportant(button, 'min-height', '72px');
        setImportant(button, 'font-size', '17px');
        setImportant(button, 'padding-left', '28px');
        setImportant(button, 'padding-right', '28px');
      });
    }

    galleryContents.forEach((galleryContent) => {
      setImportant(galleryContent, 'margin-top', '0');
      setImportant(galleryContent, 'margin-bottom', '0');
      setImportant(galleryContent, 'padding-top', '0');
      setImportant(galleryContent, 'padding-bottom', '0');
      setImportant(galleryContent, 'align-items', 'center');
      setImportant(galleryContent, 'justify-content', 'center');
    });

    thumbnails.forEach((thumbnail) => {
      setImportant(thumbnail, 'aspect-ratio', '1 / 1');
      setImportant(thumbnail, 'flex-basis', 'clamp(72px, 17vw, 94px)');
      setImportant(thumbnail, 'width', 'clamp(72px, 17vw, 94px)');
      setImportant(thumbnail, 'height', 'clamp(72px, 17vw, 94px)');
      setImportant(thumbnail, 'margin-top', '0');
      setImportant(thumbnail, 'margin-bottom', '0');
      setImportant(thumbnail, 'padding-top', '0');
      setImportant(thumbnail, 'padding-bottom', '0');
      setImportant(thumbnail, 'overflow', 'hidden');

      thumbnail.querySelectorAll('img').forEach((image) => {
        setImportant(image, 'width', '100%');
        setImportant(image, 'height', '100%');
        setImportant(image, 'object-fit', 'cover');
      });
    });

    widget.querySelectorAll('.sa-jdgm-gallery a, .sa-jdgm-gallery picture, .sa-jdgm-gallery [class*="thumbnail" i], .sa-jdgm-gallery [class*="photo" i], .sa-jdgm-gallery [class*="image" i], .sa-jdgm-gallery [class*="media" i]').forEach((galleryItem) => {
      setImportant(galleryItem, 'aspect-ratio', '1 / 1');
      setImportant(galleryItem, 'width', 'clamp(72px, 17vw, 94px)');
      setImportant(galleryItem, 'height', 'clamp(72px, 17vw, 94px)');
      setImportant(galleryItem, 'max-width', 'clamp(72px, 17vw, 94px)');
      setImportant(galleryItem, 'max-height', 'clamp(72px, 17vw, 94px)');
      setImportant(galleryItem, 'overflow', 'hidden');
      setImportant(galleryItem, 'border-radius', '10px');
    });

    widget.querySelectorAll('.sa-jdgm-gallery img').forEach((image) => {
      setImportant(image, 'display', 'block');
      setImportant(image, 'width', '100%');
      setImportant(image, 'height', '100%');
      setImportant(image, 'min-width', '100%');
      setImportant(image, 'min-height', '100%');
      setImportant(image, 'object-fit', 'cover');
      setImportant(image, 'object-position', 'center');
      setImportant(image, 'aspect-ratio', '1 / 1');
    });

    widget.querySelectorAll('.sa-jdgm-media-square').forEach((mediaItem) => {
      setImportant(mediaItem, 'position', 'relative');
      setImportant(mediaItem, 'display', 'inline-block');
      setImportant(mediaItem, 'aspect-ratio', '1 / 1');
      setImportant(mediaItem, 'flex', '0 0 clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'width', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'height', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'min-width', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'min-height', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'max-width', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'max-height', 'clamp(74px, 17vw, 98px)');
      setImportant(mediaItem, 'overflow', 'hidden');
      setImportant(mediaItem, 'border-radius', '10px');
      setImportant(mediaItem, 'background-size', 'cover');
      setImportant(mediaItem, 'background-position', 'center');
      setImportant(mediaItem, 'vertical-align', 'top');
    });

    widget.querySelectorAll('.sa-jdgm-media-square img, .sa-jdgm-media-square-img').forEach((image) => {
      setImportant(image, 'position', 'absolute');
      setImportant(image, 'inset', '0');
      setImportant(image, 'display', 'block');
      setImportant(image, 'width', '100%');
      setImportant(image, 'height', '100%');
      setImportant(image, 'max-width', 'none');
      setImportant(image, 'max-height', 'none');
      setImportant(image, 'object-fit', 'cover');
      setImportant(image, 'object-position', 'center');
      setImportant(image, 'border-radius', '10px');
    });

    widget.querySelectorAll('img.jdgm-gallery__thumbnail, img.sa-jdgm-direct-square-img').forEach((image) => {
      image.classList.remove('sa-jdgm-media-square', 'sa-jdgm-media-square-img');
      image.classList.add('sa-jdgm-direct-square-img');

      setImportant(image, 'position', 'static');
      setImportant(image, 'inset', 'auto');
      setImportant(image, 'display', 'inline-block');
      setImportant(image, 'flex', '0 0 clamp(74px, 17vw, 98px)');
      setImportant(image, 'width', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'height', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'min-width', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'min-height', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'max-width', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'max-height', 'clamp(74px, 17vw, 98px)');
      setImportant(image, 'aspect-ratio', '1 / 1');
      setImportant(image, 'overflow', 'hidden');
      setImportant(image, 'object-fit', 'cover');
      setImportant(image, 'object-position', 'center');
      setImportant(image, 'border-radius', '10px');
      setImportant(image, 'vertical-align', 'top');
      setImportant(image, 'margin', '0');
      setImportant(image, 'padding', '0');
    });

    widget.querySelectorAll('.jdgm-rev').forEach((review) => {
      const collectElementSignal = (element) => {
        if (!element) return '';

        return [
          element.textContent || '',
          element.innerHTML || '',
          element.outerHTML || '',
          element.getAttribute?.('class') || '',
          element.getAttribute?.('aria-label') || '',
          element.getAttribute?.('title') || '',
          ...Array.from(element.attributes || []).map((attribute) => `${attribute.name} ${attribute.value}`)
        ].join(' ');
      };

      const reviewHeader = review.querySelector('.jdgm-rev__header');
      const reviewRating = review.querySelector('.jdgm-rev__rating');
      const author = review.querySelector('.jdgm-rev__author, .jdgm-rev-widg__author');
      const verifiedBadges = Array.from(review.querySelectorAll('.jdgm-rev__buyer-badge, .jdgm-rev__verified-badge, [class*="verified" i], [class*="buyer" i], [aria-label*="verified" i], [title*="verified" i], [class*="shop" i], [aria-label*="shop" i], [title*="shop" i]'));
      const verified = verifiedBadges.find((badge) => /verified\s*by\s*shop|verified-by-shop|verified_by_shop|by\s*shop|shop/i.test(collectElementSignal(badge)))
        || verifiedBadges[0];
      const verifiedSourceText = [
        collectElementSignal(reviewHeader),
        collectElementSignal(author),
        ...verifiedBadges.map((badge) => collectElementSignal(badge))
      ].join(' ').replace(/\s+/g, ' ');

      reviewHeader?.classList.add('sa-jdgm-review-header');
      reviewRating?.classList.add('sa-jdgm-review-rating');
      author?.classList.add('sa-jdgm-review-author');
      verified?.classList.add('sa-jdgm-review-verified');

      if (reviewHeader && reviewRating && reviewRating.parentElement !== reviewHeader) {
        if (verified && verified.parentElement === reviewHeader) {
          verified.insertAdjacentElement('afterend', reviewRating);
        } else {
          reviewHeader.appendChild(reviewRating);
        }
      }

      if (reviewHeader && verified && author && verified.previousElementSibling !== author) {
        author.insertAdjacentElement('afterend', verified);
      }

      const timestamp = review.querySelector('.jdgm-rev__timestamp');
      const title = review.querySelector('.jdgm-rev__title');
      const body = review.querySelector('.jdgm-rev__body');
      const bodyParagraphs = review.querySelectorAll('.jdgm-rev__body p');

      setImportant(review, 'padding', '22px 26px 24px');
      setImportant(reviewHeader, 'display', 'grid');
      setImportant(reviewHeader, 'grid-template-columns', 'minmax(0, 1fr) auto');
      setImportant(reviewHeader, 'grid-template-rows', 'auto auto auto');
      setImportant(reviewHeader, 'align-items', 'start');
      setImportant(reviewHeader, 'gap', '5px 12px');
      setImportant(reviewHeader, 'margin-bottom', '14px');

      setImportant(author, 'grid-column', '1');
      setImportant(author, 'grid-row', '1');
      setImportant(author, 'align-self', 'start');
      setImportant(author, 'font-size', '16px');
      setImportant(author, 'line-height', '1.05');
      setImportant(author, 'font-weight', '800');

      setImportant(timestamp, 'grid-column', '2');
      setImportant(timestamp, 'grid-row', '1');
      setImportant(timestamp, 'align-self', 'start');
      setImportant(timestamp, 'justify-self', 'end');
      setImportant(timestamp, 'font-size', '13px');
      setImportant(timestamp, 'line-height', '1.05');
      setImportant(timestamp, 'padding-top', '1px');

      setImportant(verified, 'grid-column', '1');
      setImportant(verified, 'grid-row', '2');
      setImportant(verified, 'display', 'block');
      setImportant(verified, 'color', '#8e969d');
      setImportant(verified, 'font-size', '13px');
      setImportant(verified, 'line-height', '1.1');
      setImportant(verified, 'margin', '0');

      setImportant(reviewRating, 'grid-column', '1');
      setImportant(reviewRating, 'grid-row', '3');
      setImportant(reviewRating, 'justify-self', 'start');
      setImportant(reviewRating, 'margin', '12px 0 0');
      setImportant(reviewRating, 'font-size', '14px');
      setImportant(reviewRating, 'line-height', '1');

      setImportant(title, 'margin-top', '0');
      setImportant(title, 'color', '#686d77');
      setImportant(title, 'font-size', '14px');
      setImportant(body, 'color', '#4f555c');
      setImportant(body, 'font-size', '14px');
      setImportant(body, 'line-height', '1.32');
      bodyParagraphs.forEach((paragraph) => {
        setImportant(paragraph, 'color', '#4f555c');
        setImportant(paragraph, 'font-size', '14px');
        setImportant(paragraph, 'line-height', '1.32');
      });

      const cleanAuthor = (author?.textContent || '')
        .replace(/verified\s+by\s+shop/ig, '')
        .replace(/verified\s+by/ig, '')
        .replace(/\bverified\b/ig, '')
        .trim();
      const timestampText = (timestamp?.textContent || '').trim();
      const verifiedText = /verified\s*by\s*shop|verified-by-shop|verified_by_shop|by\s*shop|shop/i.test(verifiedSourceText)
        ? 'Verified by shop'
        : (/verified|buyer/i.test(verifiedSourceText) ? 'Verified' : 'Verified');

      let customHeader = review.querySelector('.sa-review-head');
      if (!customHeader) {
        customHeader = document.createElement('div');
        customHeader.className = 'sa-review-head';
        review.insertBefore(customHeader, review.firstElementChild);
      }

      customHeader.innerHTML = [
        '<div class="sa-review-head__top">',
        `<span class="sa-review-head__author">${cleanAuthor}</span>`,
        `<span class="sa-review-head__date">${timestampText}</span>`,
        '</div>',
        verifiedText ? `<div class="sa-review-head__verified">${verifiedText}</div>` : '',
        `<div class="sa-review-head__stars">${reviewRating ? reviewRating.innerHTML : ''}</div>`
      ].join('');

      setImportant(reviewHeader, 'display', 'none');
      setImportant(reviewRating, 'display', 'none');
    });

    if (!hasReviews) {
      if (summaryText) summaryText.textContent = 'Be the first to write a review';
    }

    widget.classList.toggle('jdgm-sa-no-reviews', !hasReviews);
    widget.classList.toggle('jdgm-sa-has-reviews', hasReviews);
    widget.classList.toggle('jdgm-sa-no-media', !hasMedia);
    widget.classList.toggle('jdgm-sa-has-media', hasMedia);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (!isSeriousAboutJudgeMeMobile()) return;

  let syncTimer;
  const scheduleJudgeMeSync = () => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncSeriousAboutJudgeMeState, 150);
  };

  syncSeriousAboutJudgeMeState();
  setTimeout(syncSeriousAboutJudgeMeState, 800);
  setTimeout(syncSeriousAboutJudgeMeState, 2000);

  document.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
    const judgeMeObserver = new MutationObserver(scheduleJudgeMeSync);

    judgeMeObserver.observe(widget, {
      childList: true,
      subtree: true
    });
  });

  const judgeMeDocumentObserver = new MutationObserver(scheduleJudgeMeSync);
  judgeMeDocumentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const addToCartPrice = document.querySelector(`#product-form-${this.dataset.section} .sa-add-to-cart-price`);
        const sourceAddToCartPrice = html.querySelector(`#product-form-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} .sa-add-to-cart-price`);
        if (addToCartPrice && sourceAddToCartPrice) addToCartPrice.innerHTML = sourceAddToCartPrice.innerHTML;
        if (addToCartPrice && sourceAddToCartPrice) addToCartPrice.dataset.basePrice = sourceAddToCartPrice.dataset.basePrice;
        updateCompleteSetAddToCartPrice(document.getElementById(`MainProduct-${this.dataset.section}`) || document);

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
